(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-badminton/assets/javascripts/status.js') >= 0) return;  svs.modules.push('/components/themes/sport-badminton/assets/javascripts/status.js'); "use strict";

(function () {
  svs = svs || {};
  svs.themes = svs.themes || {};
  svs.themes.sport_badminton = svs.themes.sport_badminton || {};

  svs.themes.sport_badminton.isEnded = function (status) {
    return !!(_.contains([25, 28, 29, 30, 31, 41], status) || status > 115 && status < 122);
  };

  svs.themes.sport_badminton.isFinished = function (status) {
    return !!_.contains([31, 41], status);
  };

  svs.themes.sport_badminton.matchNotice = function (match) {
    var matchStatus;

    switch (match.status) {
      case 23:
        matchStatus = 'Uppskjuten';
        break;

      case 24:
        matchStatus = 'Försenad matchstart';
        break;

      case 25:
        matchStatus = 'Inställd';
        break;

      case 26:
        matchStatus = 'Avbruten';
        break;

      case 28:
        matchStatus = 'Stoppad av domare';
        break;

      case 29:
      case 116:
      case 117:
        matchStatus = 'Walkover';
        break;

      case 30:
      case 118:
      case 119:
        matchStatus = 'Deltagare bröt';
        break;

      case 31:
        matchStatus = 'Slut';
        break;

      default:
        matchStatus = '';
        break;
    }

    return matchStatus;
  };

  svs.themes.sport_badminton.isLive = function (status) {
    if (window.location.href.indexOf('isMocked') > -1) {
      return true;
    }

    return !!_.contains([8, 9, 10, 11, 12, 13, 14, 26, 27], status);
  }; 


  svs.themes.sport_badminton.subscribeMatch = function (params) {
    return svs.themes.isDateHoursDiff(params.time, -5) && !svs.themes.sport_badminton.isEnded(params.status);
  };

  svs.themes.sport_badminton.hasStarted = function (status) {
    return status > 0 && !_.contains([23, 24, 25], status);
  };
})();
 })(window);